export const customernotificationsGet = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_GET',
        payload: { searchField, sortColumn, sortDirection, limit }
    }
}

export const customernotificationsGetSuccess = (items, totalItems) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_GET_SUCCESS',
        payload: { items, totalItems }
    }
}

export const customernotificationsGetError = (error) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_GET_ERROR',
        payload: error
    }
}

export const customernotificationsSetSearchField = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_SET_SEARCH_FIELD',
        payload: searchField
    }
}

export const customernotificationsSetSorting = (selectedSortOption, sortDirection) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_SET_SORTING',
        payload: { selectedSortOption, sortDirection }
    }
}

export const customernotificationsLoadMore = (searchField, sortColumn, sortDirection, limit) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_LOAD_MORE',
        payload: { searchField, sortColumn, sortDirection, limit }
    }
}

export const customernotificationsLoadMoreSuccess = (items, totalItems) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_LOAD_MORE_SUCCESS',
        payload: { items, totalItems }
    }
}

export const customernotificationsLoadMoreError = (error) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_LOAD_MORE_ERROR',
        payload: error
    }
}

export const customernotificationsDeleteItem = (itemId) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_DELETE_ITEM',
        payload: itemId
    }
}

export const customernotificationsDeleteItemSuccess = (itemId) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_DELETE_ITEM_SUCCESS',
        payload: itemId
    }
}

export const customernotificationsDeleteItemError = (error) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_DELETE_ITEM_ERROR',
        payload: error
    }
}

export const customernotificationsSetDeleted = () => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_SET_DELETED'
    }
}

export const customernotificationsUnsetDeleted = () => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_UNSET_DELETED'
    }
}

export const customernotificationsSetMessage = (message) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_SET_MESSAGE',
        payload: message
    }
}

export const customernotificationsUnsetMessage = () => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_UNSET_MESSAGE'
    }
}

export const customernotificationsUnsetError = () => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_UNSET_ERROR'
    }
}

export const customernotificationsGetDetails = (itemId) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_GET_DETAILS',
        payload: itemId
    }
}

export const customernotificationsGetDetailsSuccess = (item) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_GET_DETAILS_SUCCESS',
        payload: item
    }
}

export const customernotificationsGetDetailsError = (error) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_GET_DETAILS_ERROR',
        payload: error
    }
}

export const customernotificationsSetInsertField = (field, value) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_SET_INSERT_FIELD',
        payload: { field, value }
    }
}

export const customernotificationsInsert = (item) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_INSERT',
        payload: item
    }
}

export const customernotificationsInsertSuccess = (item) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_INSERT_SUCCESS',
        payload: item
    }
}

export const customernotificationsInsertError = (error) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_INSERT_ERROR',
        payload: error
    }
}

export const customernotificationsUnsetInserted = () => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_UNSET_INSERTED'
    }
}

export const customernotificationsSetCustomer = (customer) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_SET_CUSTOMER',
        payload: customer
    }
}

export const customernotificationsLoadUpdate = (id) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_LOAD_UPDATE',
        payload: id
    }
}

export const customernotificationsLoadUpdateSuccess = (item) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_LOAD_UPDATE_SUCCESS',
        payload: item
    }
}

export const customernotificationsLoadUpdateError = (error) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_LOAD_UPDATE_ERROR',
        payload: error
    }
}

export const customernotificationsSetUpdateField = (field, value) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_SET_UPDATE_FIELD',
        payload: { field, value }
    }
}

export const customernotificationsUpdate = (id, item) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_UPDATE',
        payload: {id, item}
    }
}

export const customernotificationsUpdateSuccess = (item) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_UPDATE_SUCCESS',
        payload: item
    }
}

export const customernotificationsUpdateError = (error) => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_UPDATE_ERROR',
        payload: error
    }
}

export const customernotificationsUnsetUpdated = () => {
    return {
        type: 'CUSTOMERNOTIFICATIONS_UNSET_UPDATED'
    }
}


